import { render, staticRenderFns } from "./CoachDocumentsGroupAction.vue?vue&type=template&id=24f4f283"
import script from "./CoachDocumentsGroupAction.vue?vue&type=script&lang=js"
export * from "./CoachDocumentsGroupAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports